import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-10 flex" }
const _hoisted_2 = { class: "flex items-center justify-center gap-2" }
const _hoisted_3 = { class: "text-sm text-black select-none" }

import { computed, ref } from "vue";
import TextInput from "@/components/inputs/TextInput.vue";
import { AuthModalMode } from "@/types/auth";
import { useI18n } from "vue-i18n";
import LoaderIcon from "@/components/icons/LoaderIcon.vue";
import ConfirmButton from "@/views/Auth/components/ConfirmButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginModalContent',
  props: {
    waitApiCall: { type: Boolean }
  },
  emits: ["changeModalMode", "login"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;

const { t } = useI18n();

const email = ref<string>("");
const password = ref<string>("");

const isCredentialsValid = computed(() => {
  const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  return (
    emailRe.test(email.value) && password.value && password.value.length > 0
  );
});

function handleLogin() {
  if (!isCredentialsValid.value) {
    return;
  }
  emits("login", email.value, password.value);
}

function handleChangeMode(newMode: AuthModalMode) {
  if (props.waitApiCall) {
    return;
  }

  email.value = "";
  password.value = "";
  emits("changeModalMode", newMode);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TextInput, {
      label: _unref(t)('auth.email'),
      modelValue: email.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
      type: "email",
      class: "mb-4"
    }, null, 8, ["label", "modelValue"]),
    _createVNode(TextInput, {
      label: _unref(t)('auth.password'),
      modelValue: password.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
      type: "password",
      class: "mb-4"
    }, null, 8, ["label", "modelValue"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", {
        class: "link-text",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (handleChangeMode('forgot')))
      }, _toDisplayString(_unref(t)("auth.forgot-password")), 1)
    ]),
    _createVNode(ConfirmButton, {
      disabled: !isCredentialsValid.value || __props.waitApiCall,
      loading: __props.waitApiCall,
      "button-text": _unref(t)('buttons.auth.login'),
      onClick: handleLogin
    }, null, 8, ["disabled", "loading", "button-text"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)("auth.dont-have-an-account")), 1),
      _createElementVNode("p", {
        class: "link-text",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (handleChangeMode('signup')))
      }, _toDisplayString(_unref(t)("auth.sign-up")), 1)
    ])
  ], 64))
}
}

})